import React from 'react';
import TextEditorDropdownButton from '../text-editor-dropdown-button';

export default function createDropdownButton({ buttons }) {
  return props => <TextEditorDropdownButton buttons={buttons} {...props}/>;
}



// WEBPACK FOOTER //
// ./app/components/text-editor/utils/create-dropdown-button.js